export default __webpack_public_path__ + "static/media/grandlale1.030ff40b.jpg";